import { Middleware, MiddlewareAPI } from 'redux';

import { SliceNameEnum } from '@app/enums';
import { mapSearchStateToUrlParams } from '@app/helpers';
import { updateSearchCriteriaAction, updateSearchFiltersAction } from '@app/state';

// Checks if action is a map search action with shouldUpdateUrl flag
function isMapSearchUpdateUrlAction(action: unknown): boolean {
    if (!action || typeof action !== 'object' || !('type' in action) || !('payload' in action)) {
        return false;
    }

    const { type, payload } = action;

    const isMapSearchAction =
        type === updateSearchCriteriaAction.type || type === updateSearchFiltersAction.type;

    const hasShouldUpdateUrlFlag =
        payload &&
        typeof payload === 'object' &&
        payload !== null &&
        'shouldUpdateUrl' in payload &&
        payload.shouldUpdateUrl === true;

    return Boolean(isMapSearchAction && hasShouldUpdateUrlFlag);
}

/**
 * Middleware to sync map search state with URL parameters.
 * Only updates the URL when actions include shouldUpdateUrl=true flag.
 */
export const mapSearchUrlMiddleware: Middleware =
    (api: MiddlewareAPI) => next => (action: unknown) => {
        const result = next(action);

        if (typeof window === 'undefined') {
            return result;
        }

        if (isMapSearchUpdateUrlAction(action)) {
            const state = api.getState();
            const mapState = state[SliceNameEnum.Map];
            const { searchCriteria, filters } = mapState;

            const searchParams = mapSearchStateToUrlParams(searchCriteria, filters);
            const url = new URL(window.location.href);
            url.search = searchParams.toString();

            window.history.replaceState({}, '', url.toString());
        }

        return result;
    };
